module.exports = __webpack_public_path__ + "static/media/Sent.524e0c42.svg";